import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

type PageParams = {
  limit: number,
  page: number,
}

type SearchParams = {
  searchText: string,
}

type SortParams = {
  sortDirection: number | undefined,
  sortFieldName: string | undefined,
}

type FilterParams = {
  departments: string[],
  roleIds: string[],
  statusIds: string[],
  groupIds: string[],
  procedureIds: string[],
  lastLoginStart: string | undefined,
}

type GroupParams = {
  inGroup: number | null,
  inGroupId: string,
}

export type GetUserParams = {
  id: string;
};

type GetUsersParams = PageParams & SearchParams & SortParams & FilterParams & GroupParams;

export const performGetUsers = async (api: IApiStore, params: EndpointCallParams<GetUsersParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('uiaggregator-app/api/v1/Users/Search', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performGetUser = async (api: IApiStore, params: EndpointCallParams<GetUserParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .get(`uiaggregator-app/api/v1/Users/${payload.id}`, {
            ...rest,
            payload,
        })

    return req;
}
